import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { sharedViewPath } from '../common/sharedView';

/**
 * Whether the current route is a read-only shared view, and `toPath` for keeping in-app links inside it.
 */
export function useSharedView() {
	const { shareKey } = useParams<{ shareKey?: string }>();
	const toPath = useCallback(
		(path: string) => (shareKey ? sharedViewPath(shareKey, path) : path),
		[shareKey],
	);
	return { shareKey: shareKey ?? null, isSharedView: Boolean(shareKey), toPath };
}
